import { Icon } from "../../atoms/icons";
import { selectOptionIconSize } from "../../atoms/select/lib";
import { selectItemColor } from "../../atoms/select/select.variants";
import { Typography } from "../../atoms/typography";
import { Box, Image } from "../../primitives";
import type { PhoneNumberFieldCountry } from "./types";

/**
 * A country row's content in both lists: the flag and name, then the calling
 * code. The picked country's name is brand/primary, with Select's filled check
 * at the end.
 */
export function CountryRowContent({
  country,
  selected,
}: {
  country: PhoneNumberFieldCountry;
  selected: boolean;
}) {
  return (
    <>
      <Box className="gap-spacing-md flex min-w-0 flex-row items-center">
        <Image src={country.flagUrl} width={24} height={18} alt={country.name} />
        <Typography
          variant="body-sm"
          color={selected ? selectItemColor.selected : selectItemColor.default}
        >
          {country.name}
        </Typography>
      </Box>
      <Box className="gap-spacing-md flex flex-row items-center">
        <Typography variant="body-sm" color="brand-primary">
          {country.dialCode}
        </Typography>
        {selected ? (
          <Icon
            name="CheckCircle"
            size={selectOptionIconSize}
            weight="fill"
            color={selectItemColor.selected}
          />
        ) : null}
      </Box>
    </>
  );
}
